export enum ContractType {
    TRADITIONAL = 'traditional',
    INTEGRATED = 'integrated',
    OTHER = 'other',
}
